import { useCount } from "@/utils/count";

const load = async () => {
    await useCount().countSurvey();
};

export default [
    {
        path: "/mall",
        name: "mall__root__",
        redirect: { name: "mall-index" },
        component: () => import("@/layouts/default.vue"),
        meta: {
            parent: "mall",
            title: "外购商城",
        },
        beforeEnter: async (to, from, next) => {
            try {
                await load();
            } catch (err) {
                console.error("[mall countSurvey error]", err);
            } finally {
                next();
            }
        },
        children: [
            {
                path: "index",
                name: "mall-index",
                component: () => import("@/views/pms/index.vue"),
                meta: {
                    title: "控制面板",
                    icon: "index",
                    affix: true,
                    permission: "view_mall_dashboard",
                },
            },
        ],
    },

    {
        path: "/mall/manage",
        name: "purchase-mall-manage",
        meta: {
            title: "商城管理",
            icon: "cms-mall-management",
            parent: "mall",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/mall/manage/goods",
        children: [
            {
                path: "goods",
                name: "purchase-mall-goods",
                component: () => import("@/views/cms/mall/goods.vue"),
                meta: {
                    title: "商品管理",
                    icon: "cms-product-management",
                },
            },
            {
                path: "good/:id(\\d+)?",
                name: "purchase-mall-goods-form",
                hidden: true,
                component: () => import("@/views/cms/mall/goods_form.vue"),
                meta: {
                    title: "商品编辑",
                    activeMenu: "/mall/manage/goods",
                    permission: "manage_mall_goods",
                },
            },
            {
                path: "good/detail/:id(\\d+)?",
                name: "purchase-mall-goods-detail",
                hidden: true,
                component: () => import("@/views/cms/mall/goods_detail.vue"),
                meta: {
                    title: "商品详情",
                    activeMenu: "/mall/manage/goods",
                },
            },
            {
                path: "order",
                name: "purchase-mall-order",
                component: () => import("@/views/cms/mall/order.vue"),
                meta: {
                    title: "订单管理",
                    icon: "mkt-mall-order",
                    permission: "mall_order_manage",
                },
            },
            {
                path: "order/detail/:id(\\d+)?",
                name: "purchase-mall-order-detail",
                hidden: true,
                component: () => import("@/views/cms/mall/order_detail.vue"),
                meta: {
                    title: "订单详情",
                    activeMenu: "/mall/manage/order",
                    permission: "mall_order_manage",
                },
            },
            {
                path: "user",
                name: "purchase-mall-user",
                component: () => import("@/views/cms/mall/user.vue"),
                meta: {
                    title: "商城用户",
                    icon: "cms-account-users",
                    permission: "manage_mall_user",
                },
            },
        ],
    },
];
